// JS
import React from 'react';
import { randomId, renderHTML } from '../shared/utils';
import Slider from '../Slider';
import FeatureLayout from './layout/FeatureLayout';
import StackedLayout from './layout/StackedLayout';

// COMPONENT
const Editorial = ({
  data,
  featureLayout = false,
  stackedLayout = false,
  gaBlockName,
  showFeatureLayoutEditorial = true,
  showSmallLayout = true,
  featureLayoutOptions,
  smallLayoutOptions,
  topMargin
}) => {
  const uniqueId = randomId();

  if (featureLayout)
    return (
      <FeatureLayout
        uniqueId={uniqueId}
        data={data}
        gaBlockName={gaBlockName}
        showFeatureLayout={showFeatureLayoutEditorial}
        featureLayoutOptions={featureLayoutOptions}
        topMargin={topMargin}
      />
    );

  if (stackedLayout)
    return (
      <StackedLayout
        uniqueId={uniqueId}
        data={data}
        gaBlockName={gaBlockName}
      />
    );

  return (
    <section
      id={'editorial-' + uniqueId}
      className={
        showSmallLayout
          ? 'container px-0 md:px-7 lg:px-8 xl:px-12 my-24 lg:my-48' +
            (smallLayoutOptions?.classes
              ? ' ' + smallLayoutOptions.classes
              : '')
          : 'hidden'
      }
    >
      {data && (
        <div
          data-name={
            data[0]?.block_title +
            ' & ' +
            data[1]?.block_title +
            ' & ' +
            data[2]?.block_title +
            ' & ' +
            data[3]?.block_title
          }
          data-creative={gaBlockName}
          data-id={
            data[0]?.contentguid +
            '-&-' +
            data[1]?.contentguid +
            '-&-' +
            data[2]?.contentguid +
            '-&-' +
            data[3]?.contentguid
          }
          data-position={'banner-slot-1'}
          data-type="banner"
        >
          <Slider
            name="editorial"
            responsive={{
              sm: {
                show: 1.25,
                spaceBetween: 5
              },
              md: {
                show: 3
              },
              lg: {
                show: 3
              },
              xl: {
                show: 4
              }
            }}
          >
            {data.map((item, i) => {
              return (
                <a
                  key={item.contentguid}
                  href={item.url}
                  className="flex items-end py-2 text-black hover:text-gray-600"
                  data-name={item.block_title + ' ' + item.block_sub_title}
                  data-creative={gaBlockName}
                  data-id={item.contentguid}
                  data-position={'button-slot-' + (i + 1)}
                  data-type="banner-button"
                >
                  <div
                    className="ml-6 md:ml-0 w-5/12 bg-cover bg-center aspect-[155/175]"
                    style={{ backgroundImage: `url(${item.icon})` }}
                  ></div>
                  <div className="w-7/12 ml-5 md:mx-5 uppercase mb-1 nq-elements">
                    <h3 className="text-xs mb-5">
                      <div className="font-semibold">{item.block_title}</div>
                      {item.block_sub_title}
                    </h3>
                    {renderHTML(item.block_description, 'text-2xs')}
                  </div>
                </a>
              );
            })}
          </Slider>
        </div>
      )}
    </section>
  );
};

export default Editorial;
